import Card from '@precis-digital/kurama/Card'
import { styled } from '@precis-digital/kurama/utils'
import { CHART_CARD_CARD_LAYOUT } from '../../constants'

const StyledCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'innerCard' && prop !== 'minWidth'
})<{ innerCard?: boolean; minWidth?: number }>(({ theme, innerCard, minWidth }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  gap: CHART_CARD_CARD_LAYOUT.gap,
  border: `1px solid ${theme.tokens.background.tonal.soft.default}`,
  borderRadius: innerCard === true ? theme.borderRadius.large : theme.borderRadius.xxLarge,
  margin: '0px',
  minWidth
}))

export default StyledCard
